import { SplitNumberInput } from '@components'

import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../../../hooks'
import { MAX_DEPOSIT_INVOICE_PERCENT } from '../../../../../../constants/maxDepositInvoicePercent'
import { DepositInvoiceAmountType } from '../../../../../../enums/depositInvoiceAmountType'
import { useDepositInvoiceForm } from '../../../../contexts/depositInvoiceDetailsFormContext'
import { useDepositInvoiceDetailsModal } from '../../../../contexts/depositInvoiceDetailsModalContext'

export const DepositInvoiceDetailsSplitAmountInput = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { quoteCurrency } = useDepositInvoiceDetailsModal()
  const { depositDetailsForm } = useDepositInvoiceForm()

  const { FormItem, watch, setValue } = depositDetailsForm

  const [depositAmount, depositType] = watch(['amount', 'type'])

  const depositTypeSelectItems = useMemo(() => {
    return [
      {
        children: '%',
        id: DepositInvoiceAmountType.Percentage,
        value: DepositInvoiceAmountType.Percentage,
      },
      {
        children: quoteCurrency,
        id: DepositInvoiceAmountType.Fixed,
        value: DepositInvoiceAmountType.Fixed,
      },
    ]
  }, [quoteCurrency])

  return (
    <FormItem
      name="amount"
      label={t('external_invoices.deposit_invoice_details_modal.form.amount.label')}
      render={({ field }) => (
        <SplitNumberInput
          {...field}
          alignment="left"
          dropdownOptions={depositTypeSelectItems}
          isFallbackToZero={false}
          max={depositType === DepositInvoiceAmountType.Percentage ? MAX_DEPOSIT_INVOICE_PERCENT : undefined}
          min={0}
          onOptionChange={(type) => {
            track('XXX - Invoicing Core - Deposit Modal - Amount type selected', { selectedType: type })
            setValue('type', type)
            if (type === DepositInvoiceAmountType.Percentage && depositAmount > MAX_DEPOSIT_INVOICE_PERCENT) {
              setValue('amount', MAX_DEPOSIT_INVOICE_PERCENT)
            }
          }}
          placeholder={t('external_invoices.deposit_invoice_details_modal.form.amount.placeholder')}
          selectedOption={depositType}
          size="sm"
          withCalculations={false}
        />
      )}
    />
  )
}
